import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MiniMoteComponent } from './mini-mote.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { LightImageModule } from '../light-image/light-image.module';

@NgModule({
    declarations: [MiniMoteComponent],
    imports: [CommonModule, SvgIconModule, LightImageModule],
    exports: [MiniMoteComponent]
})
export class MiniMoteComponentModule { }
